import type { ReactNode } from "react";
import { deriveAccentTokens, NEUTRAL_TENANT_ACCENT } from "@lms/backend/lib/design/accent";

type TenantScopeShellProps = {
  children: ReactNode;
  accent?: string;
  testId?: string;
  className?: string;
};

export function TenantScopeShell({
  children,
  accent = NEUTRAL_TENANT_ACCENT,
  testId,
  className = "flex min-h-full flex-1 flex-col bg-[var(--surface-0)] text-[var(--text-primary)]",
}: TenantScopeShellProps) {
  const light = deriveAccentTokens(accent, "light");
  const dark = deriveAccentTokens(accent, "dark");

  return (
    <div
      data-tenant-scope
      data-testid={testId}
      className={className}
      style={
        {
          ["--tenant-accent" as string]: light.accent,
          ["--accent" as string]: light.accent,
          ["--accent-strong-light" as string]: light.accentStrong,
          ["--accent-strong-hover-light" as string]: light.accentStrongHover,
          ["--accent-foreground-light" as string]: light.accentForeground,
          ["--accent-ink-light" as string]: light.accentInk,
          ["--accent-strong-dark" as string]: dark.accentStrong,
          ["--accent-strong-hover-dark" as string]: dark.accentStrongHover,
          ["--accent-foreground-dark" as string]: dark.accentForeground,
          ["--accent-ink-dark" as string]: dark.accentInk,
          ["--accent-solid" as string]: light.accentStrong,
          ["--accent-solid-hover" as string]: light.accentStrongHover,
        } as React.CSSProperties
      }
    >
      {children}
    </div>
  );
}
